import { createContext, useContext, useState, useEffect } from 'react';
import { API_ENDPOINTS, apiRequest } from '../utils/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 页面加载时检查本地存储中的用户信息
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error('解析用户信息失败:', e);
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await apiRequest(API_ENDPOINTS.LOGIN, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password })
      });

      const result = await response.json();
      
      if (response.ok && result.success) {
        // 获取用户详细信息（包括头像）
        const userResponse = await apiRequest(`${API_ENDPOINTS.USERS}?username=${result.user.username}`);
        if (userResponse.ok) {
          const userData = await userResponse.json();
          if (userData.length > 0) {
            const fullUser = {
              ...result.user,
              avatar: userData[0].avatar,
              bio: userData[0].bio
            };
            setUser(fullUser);
            localStorage.setItem('user', JSON.stringify(fullUser));
            return { success: true };
          }
        }
        
        // 如果获取详细信息失败，仍然使用基本用户信息
        setUser(result.user);
        localStorage.setItem('user', JSON.stringify(result.user));
        return { success: true };
      } else {
        return { success: false, message: result.message };
      }
    } catch (error) {
      return { success: false, message: '网络错误，请稍后重试' };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  // 强制更新用户状态（用于在其他组件中触发状态更新）
  const forceUpdate = async () => {
    if (user) {
      try {
        const response = await apiRequest(`${API_ENDPOINTS.USERS}?username=${user.username}`);
        if (response.ok) {
          const userData = await response.json();
          if (userData.length > 0) {
            const updatedUser = {
              ...user,
              avatar: userData[0].avatar,
              bio: userData[0].bio
            };
            setUser(updatedUser);
            localStorage.setItem('user', JSON.stringify(updatedUser));
          }
        }
      } catch (e) {
        console.error('更新用户信息失败:', e);
      }
    } else {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          setUser(JSON.parse(storedUser));
        } catch (e) {
          console.error('解析用户信息失败:', e);
          localStorage.removeItem('user');
        }
      }
    }
  };

  const value = {
    user,
    login,
    logout,
    loading,
    forceUpdate
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}